<div class="header">
	<div class="logo">
		<a href="https://www.dodo.com"><img src="assets/img/icons/product-icons/logo.svg" /></a>
	</div>

	<div class="title">
		<div class="icon">
			<img [src]="_planHeaderIcon" />
		</div>
		<div class="service-title" [innerHTML]="_planHeaderDesktopName"></div>
	</div>

	<div class="total">
		<div class="figures">
			<div *ngIf="_annualSavings && !isMobileOnly" class="annual-saving">
				<summary-figure-header
					[context]="_annualSavings"
				></summary-figure-header>
			</div>
			<div *ngIf="_discount && !isMobileOnly" class="percent-off">
				<summary-figure-header
					[context]="_discount"
				></summary-figure-header>
			</div>
			<div *ngIf="_dueTodayCost" class="due-today-cost">
				<summary-figure-header
					[context]="_dueTodayCost"
				></summary-figure-header>
			</div>
			<div *ngIf="_monthlyCost" class="monthly-cost">
				<summary-figure-header
					[context]="_monthlyCost"
					[hasEnergy]="_serviceName == 'Energy'"
				></summary-figure-header>
			</div>
		</div>
	</div>
</div>
